import type BookingServicePricingType from 'owa-service/lib/contract/BookingServicePricingType';
import type { BookingServiceDefaultPriceType } from 'owa-graph-schema';

const mapBookingServiceDefaultPriceType = (
    defaultPriceType: BookingServiceDefaultPriceType
): BookingServicePricingType | undefined => {
    switch (defaultPriceType) {
        case 'Undefined':
            return 0;
        case 'FixedPrice':
            return 1;
        case 'StartingAt':
            return 2;
        case 'Hourly':
            return 3;
        case 'Free':
            return 4;
        case 'PriceVaries':
            return 5;
        case 'CallUs':
            return 6;
        case 'NotSet':
            return 7;
    }
    return;
};

export default mapBookingServiceDefaultPriceType;
